import { __decorate as e, __classPrivateFieldGet as t, __classPrivateFieldSet as i } from "tslib";
import { css as s, LitElement as n, html as a } from "lit";
import { property as l, state as d } from "lit/decorators.js";
import r from "@inera/ids-design/components/mobile-menu/mobile-menu-lit.js";
import { generateId as h } from "../../../../utilities/utils.js";
var o, p, m, u, c, v, x, g, b, f;
class y extends n {
  constructor() {
    super(...arguments), o.set(this, 1), p.set(this, !1), m.set(this, !1), u.set(this, 1), c.set(this, ""), v.set(this, !1), x.set(this, "Visa meddelande"), g.set(this, "Dölj meddelande"), b.set(this, !1), f.set(this, !1), this.subItemId = h();
  }
  get level() {
    return t(this, o, "f");
  }
  set level(e) {
    i(this, o, e, "f");
  }
  get secondary() {
    return t(this, p, "f");
  }
  set secondary(e) {
    i(this, p, e, "f");
  }
  get expanded() {
    return t(this, m, "f");
  }
  set expanded(e) {
    i(this, m, e, "f");
  }
  get variation() {
    return t(this, u, "f");
  }
  set variation(e) {
    i(this, u, e, "f");
  }
  get headline() {
    return t(this, c, "f");
  }
  set headline(e) {
    i(this, c, e, "f");
  }
  get active() {
    return t(this, v, "f");
  }
  set active(e) {
    i(this, v, e, "f");
  }
  get showtext() {
    return t(this, x, "f");
  }
  set showtext(e) {
    i(this, x, e, "f");
  }
  get hidetext() {
    return t(this, g, "f");
  }
  set hidetext(e) {
    i(this, g, e, "f");
  }
  get isExpanded() {
    return t(this, b, "f");
  }
  set isExpanded(e) {
    i(this, b, e, "f");
  }
  get hasChildren() {
    return t(this, f, "f");
  }
  set hasChildren(e) {
    i(this, f, e, "f");
  }
  get childrenItems() {
    return this.querySelectorAll("ids-mobile-menu-item");
  }
  get link() {
    return this.querySelector("a");
  }
  firstUpdated(e) {
    super.firstUpdated(e), this.isExpanded = this.expanded, this.link?.setAttribute("slot", "link"), this.setupChildren();
  }
  setupChildren() {
    this.hasChildren = this.childrenItems?.length > 0, this.childrenItems?.forEach(e => {
      e.setAttribute("level", this.level + 1 + ""), e.setAttribute("slot", "sub-item");
    });
  }
  toggleExpanded() {
    if (this.hasChildren || this.headline) {
      this.isExpanded = !this.isExpanded, this.expanded = this.isExpanded;
      let e = new CustomEvent("didToggleExpansion", {
        detail: {
          isExpanded: this.expanded
        }
      });
      this.dispatchEvent(e);
    }
  }
  getLevelClass() {
    return this.level > 1 ? `--L${this.level}` : "";
  }
  getVariationClass() {
    return 2 === this.variation ? "-2" : "";
  }
  getSecondaryClass() {
    return 1 === this.level && this.secondary ? "-SECONDARY" : "";
  }
  getButtonText() {
    return this.expanded ? this.hidetext : this.showtext;
  }
  renderItem() {
    return this.headline ? a`<button @click="${this.toggleExpanded}" aria-expanded="${this.isExpanded}" aria-controls="${this.subItemId}" class="ids-mobile-menu-item__expand-btn">${this.headline}<ids-icon-chevron-bold width="0.5rem" height="0.75rem" rotate="${this.expanded ? "-90" : "90"}" class="ids-icon" color="var(--IDS-MOBILE-MENU${this.getVariationClass()}-ITEM${this.getSecondaryClass()}${this.getLevelClass()}__ICON-COLOR)" size="m"></ids-icon-chevron-bold></button>` : this.link && this.hasChildren ? a`<slot name="link"></slot><button aria-label="${this.getButtonText()}" @click="${this.toggleExpanded}" aria-expanded="${this.isExpanded}" aria-controls="${this.subItemId}" class="ids-mobile-menu-item__expand-btn"><ids-icon-chevron-bold width="0.5rem" height="0.75rem" rotate="${this.expanded ? "-90" : "90"}" class="ids-icon" color="var(--IDS-MOBILE-MENU${this.getVariationClass()}-ITEM${this.getSecondaryClass()}${this.getLevelClass()}__ICON-COLOR)" size="m"></ids-icon-chevron-bold></button>` : a`<slot name="link"></slot>`;
  }
  getItemLevelClass() {
    switch (this.level) {
      case 1:
      default:
        return "ids-mobile-menu-item";
      case 2:
        return "ids-mobile-menu-item--2";
      case 3:
        return "ids-mobile-menu-item--3";
    }
  }
  render() {
    return a`<div class="ids-mobile-menu ${2 === this.variation ? "ids-mobile-menu--variation-2" : ""}"><div class="${this.getItemLevelClass()} ${this.isExpanded ? "ids-mobile-menu-item--expanded" : ""} ${this.active ? "ids-mobile-menu-item--active" : ""} ${this.secondary ? "ids-mobile-menu-item--secondary" : ""}"><div class="ids-mobile-menu-item__inner">${this.renderItem()}</div><div id="${this.subItemId}" class="ids-mobile-menu-item__sub-items"><slot name="sub-item"></slot></div></div></div>`;
  }
}
o = new WeakMap(), p = new WeakMap(), m = new WeakMap(), u = new WeakMap(), c = new WeakMap(), v = new WeakMap(), x = new WeakMap(), g = new WeakMap(), b = new WeakMap(), f = new WeakMap(), y.styles = [r, s`:host{width:100%}`], e([l({
  type: Number
})], y.prototype, "level", null), e([l({
  type: Boolean
})], y.prototype, "secondary", null), e([l({
  type: Boolean,
  reflect: !0
})], y.prototype, "expanded", null), e([l({
  type: Number
})], y.prototype, "variation", null), e([l({
  type: String
})], y.prototype, "headline", null), e([l({
  type: Boolean,
  reflect: !0
})], y.prototype, "active", null), e([l({
  type: String
})], y.prototype, "showtext", null), e([l({
  type: String
})], y.prototype, "hidetext", null), e([d()], y.prototype, "isExpanded", null), e([d()], y.prototype, "hasChildren", null);
export { y as IDSMobileMenuItem };